import { useToastStore } from '../store/toastStore';

export default function Toast() {
  const { message, variant, clear } = useToastStore();
  if (!message) return null;

  return (
    <div
      onClick={clear}
      className={`fixed left-1/2 top-4 z-[100] w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 rounded-xl border px-4 py-3 text-sm shadow-lg ${
        variant === 'error'
          ? 'border-red-800 bg-red-950/95 text-red-100'
          : 'border-mlbb-border bg-mlbb-card text-white'
      }`}
    >
      {message}
    </div>
  );
}
